<template>
  <div class="trivia-container">
    <div class="timer"><h3>:20</h3></div>
    <div class="trivia">
      <Chapter chapter="1" />
      <Title title="Trivia" />
      <TransparentBox>
        <p class="bold">You have <span class="orange">20 seconds</span> to answer questions in each of 4 safety categories.</p>
        <p>You may skip questions, but points will be deducted.</p>
        <img src="../assets/trivia_img.png" class="trivia-img" />
        <router-link to="/trivia/category">
          <Button color="orange" buttonText="Play!" class="button"></Button>
        </router-link>
      </TransparentBox>
    </div>
  </div>
</template>

<script>
import Button from '@/components/Button.vue'
import Title from '@/components/Title.vue'
import Chapter from '@/components/Chapter.vue'
import TransparentBox from '@/components/TransparentBox.vue'

export default {
  name: 'trivia',
  components: {
    Button,
    Title,
    Chapter,
    TransparentBox
  },
  props: {
    heading: String,
    color: String,
    buttonText: String,
    path: String,
    chapter: Number
  },
  data() {
    return {
      firstQuestionId: null
    }
  },
  mounted() {
    this.$ga.page('/trivia')
  }
}
</script>

<style scoped>
  .trivia {
    left: 50%;
    position: absolute;
    top: 300px;
    transform: translateX(-50%);
  }

  .trivia-img {
    position: absolute;
    right: -100px;
    top: 100px;
  }

  .button {
    bottom: -38px;
    left: 100px;
    position: absolute;
  }

  .orange {
    color: #fdba07;
  }

  p {
    color: #fff;
    font-size: 32px;
    text-align: left;
    max-width: 605px;
    margin: 35px 0;
  }

  .bold {
    font-size: 36px;
    font-weight: bold;
  }

  .timer {
    background: url('../assets/timer_bg.png') top center no-repeat;
    height: 210px;
    position: absolute;
    left: 50%;
    margin-bottom: 50px;
    top: 0;
    transform: translateX(-50%);
    width:279px;
  }

  h3 {
    bottom:40px;
    color: #fff;
    font-size: 62px;
    font-weight: 900;
    left: 50%;
    margin: 0;
    position: absolute;
    transform: translateX(-50%);
  }
</style>